// src/features/tidsregistering/services/sickLeaveTrackers.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/sick-leave-trackers';

export const sickLeaveTrackersAPI = {
  listForDepartment: () =>
    apiClient.get(`${BASE}/department`),

  getTracker: (staffMemberId) =>
    apiClient.get(`${BASE}/staff/${staffMemberId}`),

  rebuildTracker: (data) =>
    apiClient.post(`${BASE}/rebuild`, data),

  recordDoctorNote: (data) =>
    apiClient.post(`${BASE}/doctor-note`, data),
};
